<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GJW0BO/tc-custom/9781504041126.jpg?1734177929819" alt="This image is the cover for the book Man Who Would Be King"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Man Who Would Be King
      </h1>
      <p class="bookDescription body article font2">
        <b>Swashbuckling British adventurers find triumph and tragedy in nineteenth-century Afghanistan in this novella J. M. Barrie called “the most audacious thing in fiction.”</b><br/>  <br/> While on tour in India, a British journalist encounters Daniel Dravot and Peachey Carnehan, two foolhardy drifters with a plan. Claiming they’ve exhausted all the schemes and odd jobs they could find in India, the two are in search of an even greater adventure. They tell the journalist they’re venturing to nearby Kafiristan—modern-day Afghanistan—to depose a weak ruler and establish themselves as kings. With a cache of the best rifles and knowledge of Masonic rituals that will baffle the native tribesmen, Daniel and Peachey don’t see how they can fail. But they may have underestimated the locals . . .<br/>  <br/> Inspired by tales of real-life explorers, Rudyard Kipling wrote <i>The Man Who Would Be King</i> when he was only twenty-two years old. Featuring vivid prose, exotic settings, and unforgettable characters, this dissection of the heroic pretensions of imperialism and colonialism is a swashbuckling tale for the ages, and served as inspiration for the 1975 John Huston film starring Sean Connery and Michael Caine.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rudyard Kipling
      </h2>
      
      <p class="authorDescription body article">&amp;lt;B&amp;gt;Rudyard Kipling&amp;lt;/B&amp;gt; was born in Bombay, India, in 1865. One of the most revered writers in recent history, many of his works are deemed classic literature. To this day, he maintains an avid following and reputation as one of the greatest storytellers of the past two centuries. In 1907, he received the Nobel Prize for Literature. He died in 1936, but his stories live on&amp;#8212;even eighty years after his passing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01419c8a